import s from "./JourneyCard.module.scss"

export const JourneyCardSkeleton = () => {
  return (
    <div className={s.skeleton}>
      <div className={s.skeleton__bottomType} />
      <div className={s.skeleton__bottomTitle} />
    </div>
  )
}
